import { cn } from "@/lib/utils";

const MAP = {
  terbuka: ["Terbuka", "bg-teal-50 text-teal-800 border-teal-100"],
  ada_penawaran: ["Ada Penawaran", "bg-amber-50 text-amber-800 border-amber-100"],
  dipilih: ["Dipilih", "bg-emerald-50 text-emerald-800 border-emerald-100"],
  dibatalkan: ["Dibatalkan", "bg-stone-100 text-stone-600 border-stone-200"],
  kedaluwarsa: ["Kedaluwarsa", "bg-rose-50 text-rose-700 border-rose-100"],
  menunggu: ["Menunggu", "bg-amber-50 text-amber-800 border-amber-100"],
  diterima: ["Diterima", "bg-emerald-50 text-emerald-800 border-emerald-100"],
  ditolak: ["Ditolak", "bg-stone-100 text-stone-500 border-stone-200"],
  menunggu_pembayaran: ["Menunggu Pembayaran", "bg-amber-50 text-amber-800 border-amber-100"],
  dibayar: ["Dibayar", "bg-sky-50 text-sky-800 border-sky-100"],
  dikerjakan: ["Dikerjakan", "bg-teal-50 text-teal-800 border-teal-100"],
  menunggu_konfirmasi: ["Menunggu Konfirmasi", "bg-violet-50 text-violet-800 border-violet-100"],
  selesai: ["Selesai", "bg-emerald-50 text-emerald-800 border-emerald-100"],
  dikomplain: ["Dikomplain", "bg-rose-50 text-rose-700 border-rose-100"],
};

export const StatusBadge = ({ status, testId, className }) => {
  const [label, cls] = MAP[status] || [status, "bg-stone-100 text-stone-600 border-stone-200"];
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={cn("inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold", cls, className)}
    >
      {label}
    </span>
  );
};
